import React, { Component } from "react";

// import TableView Component
import TableView from 'pages/common/TableView';

import { AuthStore } from "store";

import { 
  fetchSpeciesTotalCount,
  fetchAllSpecies, 
} from 'services/species-details';

import speciesFields from './species.fields';

import { permissionCheck } from 'permissions'; 

export default class SupplierList extends Component {

  constructor(props) {
    super(props);
    
    this.currentUser = AuthStore.state.currentUser;
    this.state = { updateContent : false };
    
    this.tableProps = {
      // table state
      updateContent : false,
      
      // table header props
      title : 'List of All Species',
      addButtonText : 'Add New Species',
      addUrl : permissionCheck('common', 'species-create') ? '/aqf/admin/species-details/add' : null,
      searchEnable : true,              
      searchPlaceholder : 'Search By Name',
      
      // table content props
      columns : speciesFields,
      itemUrlPath : null,
      editUrlPath : permissionCheck('common', 'species-update') ?  '/aqf/admin/species-details/edit/' : null,
      multiDeleteEnabled : false,
      
      // define service APIs.
      fetchDataApi : this.fetchSpeciesDataWrapper,
      fetchCountApi : this.fetchSpeciesCountWrapper,
      deleteMultipleApi : null,
      deleteSingleApi : null,
      
      // define filters
      selectFilters : [],
      
      // export to xl, pdf props
      exportEnable : false,
    };
  }
  
  fetchSpeciesCountWrapper = async(filters, searchValue) => {
    let response = await fetchSpeciesTotalCount({
      name : searchValue
    });
    return response;
  }

  fetchSpeciesDataWrapper = async (page, perPage, filters, searchValue) => {
    let response = await fetchAllSpecies({
      page: page,
      per_page: perPage,
      name : searchValue
    });
    
    if (response && response.status === 200) {
      response.data.forEach(entry => {
        entry.selection = false;
        entry.url = `/aqf/admin/species-details/edit/${entry.id}`;
      });
    }
    
    return response;
  }

  async componentDidMount() {
    this.tableProps.updateContent = true;
    await this.setState({updateContent : true});
  }
  
  async componentDidUpdate(prevProps, prevState) { 
    if (this.tableProps.updateContent) {
      this.tableProps.updateContent = false;
      await this.setState({updateContent : false});
    }
  }


  render() {
    return (
      <TableView {...this.props} {...this.tableProps}/>
    );
  }
}